import React from 'react';
import { useSnackbar, OptionsObject, WithSnackbarProps } from 'notistack';
import { Button, CircularProgress } from '@mui/material';

export enum VariantType {
  default = 'default',
  error = 'error',
  success = 'success',
  warning = 'warning',
  info = 'info',
}

interface SnackProps {
  setUseSnackbarRef: (showSnackbar: WithSnackbarProps) => void;
}

let useSnackbarRef: WithSnackbarProps;
const setUseSnackbarRefX = (useSnackbarRefProp: WithSnackbarProps) => {
  useSnackbarRef = useSnackbarRefProp;
};

// eslint-disable-next-line func-names
const InnerSnackbarUtilsConfigurator: React.FC<SnackProps> = function ({
  setUseSnackbarRef,
}) {
  setUseSnackbarRef(useSnackbar());
  return null;
};

export function SnackbarUtilsConfigurator(children?: React.ReactNode) {
  return (
    <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRefX}>
      {children}
    </InnerSnackbarUtilsConfigurator>
  );
}

const defaultSnackMessageLength = 1000;

const trimMessage = (
  msg: string,
  length: number = defaultSnackMessageLength
) => {
  return msg.substring(0, length);
};

export default {
  success(msg: string, options: OptionsObject = {}) {
    this.toast(trimMessage(msg), {
      ...options,
      variant: VariantType.success,
      preventDuplicate: true,
    });
  },
  warning(msg: string, options: OptionsObject = {}) {
    this.toast(trimMessage(msg), {
      ...options,
      variant: VariantType.warning,
      preventDuplicate: true,
    });
  },
  info(msg: string, options: OptionsObject = {}) {
    this.toast(trimMessage(msg), {
      ...options,
      variant: VariantType.info,
      preventDuplicate: true,
    });
  },
  error(msg: string, options: OptionsObject = {}) {
    this.toast(trimMessage(msg), {
      ...options,
      variant: VariantType.error,
      preventDuplicate: true,
      anchorOrigin: {
        horizontal: 'center',
        vertical: 'top',
      },
    });
  },
  confirmationError(msg: string, options: OptionsObject = {}) {
    this.toast(trimMessage(msg), {
      ...options,
      variant: VariantType.error,
      preventDuplicate: true,
      persist: true,
      anchorOrigin: {
        horizontal: 'center',
        vertical: 'top',
      },
    });
  },
  toast(msg: string, options: OptionsObject = {}) {
    useSnackbarRef.enqueueSnackbar(msg, options);
  },
  loading(msg: string, options: OptionsObject) {
    this.toast(trimMessage(msg), {
      ...options,
      variant: 'info',
      persist: true,
      content: (id: number) => {
        return (
          <div key={id} style={{ width: '100%' }}>
            <CircularProgress color="primary" />
          </div>
        );
      },
    });
  },
};
